import React from 'react';
import { footerData } from '../mockData';
import { Twitter, Linkedin, Github, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const iconMap = {
    'Twitter': Twitter,
    'Linkedin': Linkedin,
    'Github': Github
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Footer Top */}
        <div className="footer-top">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-rails">RAILS</span>
              <span className="logo-separator">by</span>
              <span className="logo-dx">DX</span>
            </div>
            <p className="footer-about">{footerData.about}</p>
            
            {/* Social Links */}
            <div className="social-links">
              {footerData.social.map((social) => {
                const Icon = iconMap[social.icon];
                return (
                  <a 
                    key={social.platform} 
                    href={social.href}
                    className="social-link"
                    aria-label={social.platform}
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="link-list">
              {footerData.links.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="footer-link">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-contact">
            <h4 className="footer-heading">Get in Touch</h4>
            
            <div className="contact-section">
              <div className="contact-icon-wrapper">
                <Mail size={18} />
              </div>
              <div className="contact-details">
                <p className="contact-label">Email</p>
                {footerData.contact.emails.map((email, idx) => (
                  <a key={idx} href={`mailto:${email.mailto}`} className="contact-link">
                    {email.display}
                  </a>
                ))}
              </div>
            </div>

            <div className="contact-section">
              <div className="contact-icon-wrapper">
                <Phone size={18} />
              </div>
              <div className="contact-details">
                <p className="contact-label">WhatsApp Only</p>
                {footerData.contact.whatsapp.map((phone, idx) => (
                  <a key={idx} href={`https://wa.me/${phone.replace(/\s+/g, '')}`} className="contact-link">
                    {phone}
                  </a>
                ))}
              </div>
            </div>

            <div className="contact-section">
              <div className="contact-icon-wrapper">
                <MapPin size={18} />
              </div>
              <div className="contact-details">
                <p className="contact-label">Locations</p>
                {footerData.contact.locations.map((location, idx) => (
                  <p key={idx} className="contact-location">{location}</p>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="copyright">{footerData.copyright}</p>
          <div className="footer-legal">
            <a href="#privacy" className="legal-link">Privacy Policy</a>
            <span className="legal-divider">•</span>
            <a href="#terms" className="legal-link">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
